
import React from 'react';
import {  Divider } from 'antd'
import $$ from 'cmn-utils';
import { utils_tool } from '@/tool';
let { Storage } = utils_tool;

  export const wizModalFormColumns=(self, data) => {

    return [
    {
      name: "id",
      formItem: {
        type: "hidden",
      }
    },
    {
      name: "order",
      formItem: {
        type: "hidden",
      }
    },

    {
      title: "场景名称",
      name: "sceneName",
      dataIndex: "sceneName",
      formItem: {
        rules: [
          {
            required: true,
            message: "请输入场景名称"
          },
        ]
      }
    }
    ,


        {
            title: "通知类型",
            name: "sendType",
            dataIndex: "sendType",
            dict: [
              { code: 0, codeName: "站内通知" },
              { code: 1, codeName: "推送消息" },
              { code: 3, codeName: "短信通知" },
              { code: 4, codeName: "邮件通知" },
              // { code: 5, codeName: "企业微信" },
              { code: 6, codeName: "智能电话" },
            ],
            tableItem: {
            },
            formItem: {
                type: "select",
                mode:"multiple",
                allowClear: true
            }
          },
  ]
};
